import type { SIDEBAR_ENVIRONMENT } from "@bcmi-labs/cloud-sidebar"
import { CloudContextProvider } from "@bcmi-labs/cloud-sidebar"

import { useRecap } from "@/api/hooks/useRecap"
import { useSpace } from "@/api/hooks/useSpace"
import { env } from "@/env"
import { SpaceStorageInstance } from "@/lib/services/instances"

const SIDEBAR_ENV: typeof SIDEBAR_ENVIRONMENT = {
  DIGITAL_STORE_URL: env.VITE_STORE,
  ID_URL: env.VITE_ID_URL,
  ICON_CDN: env.VITE_CDN,
  CLOUD_HOME_URL: ""
}

// Handle the cloud context for the sidebar, but wire it with our internal state management.
export function CloudContext(props: { children: React.ReactNode }) {
  const { spaceList } = useSpace()
  const { userRecap } = useRecap()

  return (
    <CloudContextProvider
      spaces={spaceList.data}
      privateSpacePlans={userRecap.data?.plans || []}
      storage={SpaceStorageInstance}
      refetchSpaces={() =>
        spaceList.refetch({ throwOnError: true }).then(res => {
          // Reject rather than resolve with `[]`: the sidebar reads an empty list as "space not found" and resets the cookie.
          if (!res.data) throw new Error("Space list is empty after refetch")
          return res.data
        })
      }
      env={SIDEBAR_ENV}>
      {props.children}
    </CloudContextProvider>
  )
}
